<template>
    <section>
        <titlebar :title-stack="titleStack"></titlebar>
        <b-table :data="model.lista"
                 :loading="loading"
                  :bordered="true"
                 :paginated="false"
                 striped
                 hoverable
                 backend-pagination
                 :total="total"
                 @page-change="onPageChange"
                 :aria-next-label="$t('SISTEMA.PROXPAGINA')"
                 :aria-previous-label="$t('SISTEMA.PAGINAANTERIOR')"
                 :aria-page-label="$t('SISTEMA.PAGINA')"
                 :aria-current-label="$t('SISTEMA.PAGINAATUAL')"
                 backend-sorting
                 :default-sort-direction="defaultOrdenar"
                 :default-sort="[ordenarPor, ordenar]"
                 sort-icon-size="is-small"
                 :row-class="(row, index) => verificaAtraso(row) "
                 @sort="onSort"
                 class="float-header">

            <template >
                <b-table-column  v-slot="props" field="Id" :label="$t('SISTEMA.CODIGO')" >

                    {{ props.row.clienteCodigoExterno }}

                    <span>
                        <b-icon v-if="props.row.dataHoraCancelado !=null"
                                        icon="close-circle"
                                        size="is-small"
                                        :title="$t('GUIALIST.ATENDIMENTOCANCELADO')"
                                        type="is-danger"></b-icon>
                        <span class="cp" @click="exibirHistoricoUrgencia(props.row.id)">
                            <b-icon v-if="props.row.urgente" 
                                    icon="bookmark"
                                    size="is-small"
                                    class="bookmark-custom-style"></b-icon>                                            
                        </span>

                        <b-icon v-if="props.row.dataHoraVenda !=null || props.row.dataHoraEfetivacao !=null "
                                        icon="currency-usd"
                                        size="is-small"
                                        :title="$t('GUIALIST.ATENDIMENTOVENDAEFETIVADO')"
                                        type="is-success"></b-icon>
                        <b-icon v-if="props.row.dataHoraBloqueado !=null"
                                        icon="account-alert"
                                        size="is-small"
                                        :title="$t('GUIALIST.CLIENTEEMESPERA')"
                                        type="is-warning"></b-icon>
                        <b-icon v-if="props.row.status == 5"
                                        icon="archive-outline"
                                        size="is-small"
                                        :title="$t('GUIALIST.POSVENDA')"
                                        ></b-icon>
                        <b-icon v-if="props.row.guiaVinculadaId > 0"  icon="link"
                                        size="is-small"
                                        :title="$t('GUIALIST.ATENDIMENTOVINCULADO')"
                                        type="is-link"></b-icon>
                        <b-icon v-if="props.row.tipo == 2"
                            icon="cog"
                            size="is-small"
                            :title="$t('VENDAS.ASSISTENCIA')"></b-icon>
                        <b-icon v-if="props.row.tipo == 3"
                                        icon="tools"
                                        size="is-small"
                                        :title="$t('VENDAS.MOSTRUARIO')"></b-icon>
                    </span>
                </b-table-column>

                <b-table-column v-slot="props" field="ClienteNome" :label="$t('SISTEMA.CLIENTE')" sortable  >
                        <b-tooltip  size="is-small" position="is-top" type="is-light"  >
                            <template  v-slot:content>
                                <span >
                                    <b>ARQUITETO: </b>  {{props.row.clienteArquiteto}}
                                </span>
                                <br>
                                <span v-if="props.row.temperatura>0">
                                    <small style="margin-top: -5px !important;display: block; font-size: 0.7em;">
                                        <b> TEMPERATURA: </b> {{props.row.temperaturaNome}}
                                        </small>
                                </span>
                                <span v-if="props.row.valorVenda>0">
                                    <small style="margin-top: -5px !important;display: block; font-size: 0.7em;">
                                        <b>VALOR VENDA: </b> {{props.row.valorVendaFormatado}}
                                    </small>
                                </span>
                                <span v-if="props.row.codigoContrato>0">
                                    <b>CONTRATO: </b> {{props.row.codigoContrato}}
                                    <br>
                                </span>
                            </template>
                            <span class="is-size-7">{{ props.row.clienteNome }}</span>
                        </b-tooltip>
                        <span>
                            <a class="has-text-info" @click="verStatusAtual(props.row,false)" :title="$t('GUIALIST.VERSTATUS')">
                                <b-icon  icon="eye" size="is-small"></b-icon>
                            </a>
                        </span>
                        <span v-if="props.row.inside && props.row.atraso" class="is-size-7 is-block"><b><i>INSIDE</i></b> </span>
                </b-table-column>

                <b-table-column v-slot="props" field="VendedorNome" :label="$t('GUIALIST.VENDEDOR')"  >
                    <p v-if="props.row.funcionarioComercialNome" class="is-size-7 columns-nowrap-10" :title="props.row.funcionarioComercialNome.toUpperCase()"> {{ props.row.funcionarioComercialNome.toUpperCase() }}</p>
                </b-table-column>

                <b-table-column v-slot="props" field="DataDeEmissao" :label="$t('GUIALIST.EMISSAO')"  >
                    {{ $moment(props.row.dataHoraCadastro).format("DD/MM/YYYY HH:mm") }}
                </b-table-column>
                
                <b-table-column  v-slot="props" custom-key="actions" numeric >
                    <router-link  :to="{ name: 'guia', params: { id: props.row.id, guiaList: true}}" class="button is-small is-primary" title="Editar">
                        <b-icon icon="pencil" size="is-small"></b-icon>
                    </router-link>             
                    <b-button   class="is-small ml-1" @click="confirmarInclusaoObservacao( props.row)" 
                    :title="$t('GUIAATENDIMENTO.INCLUIROBSERVACAO')" icon-left="comment"></b-button>      
                    <b-button class="is-small ml-1" type="is-info" size="is-small" @click="exibirHistorico(props.row.id)" icon-left="clock" :title="$t('GUIAATENDIMENTO.HISTORICODEOBSERVACOES')"></b-button>                                                                                                                                                                                            
                    <b-button  class="is-small ml-1" v-if="isInRole('atendimento-alterarurgencia')"
                        :title="$t('GUIALIST.ALTERARURGENCIA')"
                        
                        @click="confirmarAlteracaoUrgencia(props.row)">
                        <b-icon
                            :icon="!props.row.urgente ? 'bookmark' : 'bookmark-off'"
                            size="is-small"
                            :class="!props.row.urgente ? 'bookmark-custom-style' : ''"></b-icon>
                    </b-button>
                </b-table-column>

                                    
                
            </template>
        </b-table>

        <nav class="level">
            <div class="level-item">
                <p class="buttons">
                    <b-button type="is-danger"
                                native-type="button"
                                icon-left="close-circle"
                                @click="$router.back();">
                        {{$t('SISTEMA.VOLTAR')}}
                    </b-button>
                </p>
            </div>
        </nav>
    </section>
</template>

<style scoped>
    .has-background-dark {
        background-color: #363636d6 !important;
    }
</style>

<script>
    import titlebar from '@/components/titlebar.vue'
    import debounce from 'lodash/debounce'
    import modalVerStatusAtualGuia from '@/components/atendimento/modalVerStatusAtualGuia.vue'
    import modalObservacaoGuia  from '@/components/atendimento/modalObservacaoGuia'
    import modalHistoricoObservacoesGuia  from '@/components/atendimento/modalHistoricoObservacoesGuia'
    import modalHistoricoObservacoesUrgenciaGuia  from '@/components/atendimento/modalHistoricoObservacoesUrgenciaGuia.vue'
    
    import { mapState, mapGetters } from 'vuex'

    export default {
        data(){
            return {
                model: [],
                total: 0,
                loading: false,
                ordenarPor: '',
                ordenar: '',
                defaultOrdenar: '',
                page: 1,
                perPage: 20,
            }
        },
        components: {
            titlebar,
        },
        computed: {
            titleStack() {
                return [
                    this.$t('SISTEMA.ATENDIMENTO'),
                    this.$t('GUIALIST.URGENCIA'),
                ]
            },
            ...mapState([
                'unidadeId',
            ]),
            ...mapGetters([
                'isInRole'
            ])
        },
        watch: {
            unidadeId: function(novaUnidade) {
                this.loadAsyncData();
            },
        },
        methods: {
            exibirHistoricoUrgencia(guiaId){
                this.$buefy.modal.open({
                    parent: this,
                    component: modalHistoricoObservacoesUrgenciaGuia,
                    props: {
                        guiaId,
                    },
                    hasModalCard: true,
                    trapFocus: true,
                    fullScreen: false
                })
            },  
            exibirHistorico(guiaId) {
                this.$buefy.modal.open({
                    parent: this,
                    component: modalHistoricoObservacoesGuia,
                    props: {
                        guiaId,
                    },
                    hasModalCard: true,
                    trapFocus: true,
                    fullScreen: false
                })
            },

            confirmarInclusaoObservacao(item) {
                this.$buefy.modal.open({
                    parent: this,
                    component: modalObservacaoGuia,
                    props: {
                        guia: item                                             
                    },
                    events: {
                        loadData: this.loadAsyncData()
                    },                    
                    hasModalCard: true,
                    trapFocus: true
                })
            },                  
            confirmarAlteracaoUrgencia(item){
                this.$buefy.dialog.confirm({
                    message: this.$t('GUIALIST.MGSALTERARURGENCIA'),
                    cancelText: this.$t('SISTEMA.NAO'),
                    confirmText: this.$t('SISTEMA.SIM'),
                    onConfirm: () => {
                        const params = [];
                        params.push(`guiaId=${item.id}`);
                    
                        this.$http.post(`/api/atendimento/AlterarUrgenciaGuia?${params.join('&')}`)
                            .then(() => {
                                this.$buefy.toast.open({
                                    duration: 5000,
                                    message: this.$t('GUIALIST.URGENCIAALTERADASUCESSO'),
                                    type: 'is-success',
                                    queue: false
                                });

                                this.loadAsyncData();
                            });
                    },
                });
            },
            verStatusAtual(guia){
                this.$http.get(`/api/atendimento/VerStatusAtual?id=${guia.id}`)
                .then(res => res.data)
                .then(data => {
                    this.$buefy.modal.open({
                        parent: this,
                        component: modalVerStatusAtualGuia,
                        props: {
                            processo: data.processo,
                            etapa: data.etapa,
                            clienteNome: guia.clienteNome
                        },
                        hasModalCard: true,
                        trapFocus: true
                    })
                });
                return;
            },
            verificaAtraso(row){
                let classe = "";

                let temperatura="";

                if (row.temperatura == 1){
                    temperatura = " frio";
                }else if (row.temperatura == 2){
                    temperatura = " morno";
                }else if (row.temperatura == 3){
                    temperatura = " quente";
                }

                if(row.inside)
                    classe = 'has-background-dark has-text-white ';

                if(row.atraso)
                    classe = 'bg-atraso ';

                return classe + temperatura;
            },
                     
            loadAsyncData: debounce(function () {
                const params = this.montaParametros();

                this.loading = true;

                const url = `/api/atendimento/procurar?${params.join('&')}`;

                this.$http.get(url)
                    .then(({ data }) => {
                        this.model = data;
                    })
                    .catch((error) => {
                        this.model = []
                        this.total = 0
                        throw error
                    }).finally(() => {
                        this.loading = false
                    });
            }, 500),
            montaParametros(){
                const params = [
                    `unidadeId=${this.unidadeId}`,
                    `page=${this.page}`,
                    `urgente=${true}`
                ];

                if(this.ordenarPor && this.ordenar)
                    params.push(`ordem=${this.ordenarPor}.${this.ordenar}`);

                return params;
            },
            onPageChange(page) {
                this.page = page
                this.loadAsyncData()
            },
            onSort(field, order) {
                this.ordenarPor = field
                this.ordenar = order
                this.loadAsyncData()
            },
        },
        async mounted() {
            await this.loadAsyncData();
        }
    }
</script>